import { PendingTransactionsTable } from './pendingTransactionsTable';

export default PendingTransactionsTable;